import { MutationTree } from 'vuex'
import { Auth } from './types'
import { getDefaultState } from './index'

export const mutations: MutationTree<Auth> = {
  auth_request(state) {
    state.status = 'loading'
  },
  auth_success(state, token) {
    state.status = 'success'
    state.token = token
    state.tokenValid = true
  },
  auth_error(state) {
    state.status = 'error'
  },
  logout(state) {
    Object.assign(state, getDefaultState())
  },
  setUser(state, user) {
    state.user = user
  },
  wsConnectionActive(state, payload) {
    state.wsConnectionActive = payload
  },
  setConnection(state, payload) {
    state.connection = payload
  },
  setSession(state, payload) {
    state.session = payload
  },
  tokenValid(state, resp) {
    state.tokenValid = resp
  },
  accountData(state, data) {
    state.accountData = data
  },
  latestVersionTermsConditions(state, data) {
    state.latestVersionTermsConditions = data
  },
  termsConditionsBlocker(state, value) {
    state.termsConditionsBlocker = value
  },
  userIsAdmin(state, value) {
    state.userIsAdmin = value
  },
  accountVersionAccepted(state, value) {
    state.accountVersionAccepted = value
  },
  setAccountInformation(state, payload) {
    state.accountInformation = payload
  }
}
